export const extractZipFromBlob = (
  blob: Blob,
  options?: { filename?: string },
) => {
  const filename = options?.filename || `${s__('Download|documents')}.zip`;
  // Trigger download using a hidden 'a' node
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.style.display = 'none';
  a.href = url;
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
